import { render } from "./ToggleButton.vue?vue&type=template&id=7982522c&scoped=true&ts=true"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"

import "./ToggleButton.vue?vue&type=style&index=0&id=7982522c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7982522c"]])

export default __exports__